import { render } from "./Pagination.vue?vue&type=template&id=849a166c"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=849a166c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "849a166c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('849a166c', __exports__)) {
    api.reload('849a166c', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=849a166c", () => {
    api.rerender('849a166c', render)
  })

}


export default __exports__